import { useState } from "react";
import classes from "./RemarksField.module.css";

export default function RemarksField({ title, changeHandler }) {
  const [answer, setAnwer] = useState("");

  let maxLength = 250;
  let type = "text";

  

   
   
  
  function capitalizeFirstWord(value) {
    return value.replace(/^(\s*)(\S)/, (_, leadingSpace, firstCharacter) => {
      return `${leadingSpace}${firstCharacter.toUpperCase()}`;
    });
  }

  function dataValidationBasic(e) {
    let ans = capitalizeFirstWord(e.target.value);

    let ansLength = ans.length;

    if (ansLength <= maxLength) {
      setAnwer(ans);
      console.log(title, ans);
      changeHandler(title, ans);
    }
  }

  return (
    <>
      <div className={classes.simpleQuestions}>
        <label htmlFor="fname">
          {title}
          
            <span>{`${maxLength - answer.length}`}</span>
        
        </label>{" "}
        <br></br>
        
          <textarea
            type={type}
            name={title}
            maxLength={maxLength}
            value={answer}
            onChange={(e) => dataValidationBasic(e)}
          />
       
        <br />
        <br />
      </div>
    </>
  );
}
